<template>
  <div
    class="intro fade-in"
    v-if="!hideUi && isData"
    :class="{ shown: isData }"
  >
    <div class="btns fade-in" :class="{ shown: showBtns }">
      <img
        :src="getPic('info')"
        class="info btn hoverable-button"
        handler-id="info"
        @load="loadPics('info')"
        @mouseover="handleHoverEvent('info')"
        @mouseout="handleUnhoverEvent('info')"
        @click="handleActivateEventInComponent('info')"
        alt=""
      />
      <img
        :src="getPic('white')"
        class="white btn hoverable-button"
        handler-id="white"
        @load="loadPics('white')"
        @mouseover="handleHoverEvent('white')"
        @mouseout="handleUnhoverEvent('white')"
        @click="handleActivateEventInComponent('white')"
        alt=""
      />
    </div>
    <div
      class="btns langcontent fade-in" :id="isNotEnglish"
      :class="{ shown: showBtns }"
      v-html="$t('homePageTexts.videoContentForAnimationIntroSecond')"
    ></div>
    <div
      class="btns langcontent fade-in" :id="isNotEnglish"
      :class="{ shown: isFirstIntroActive }"
      v-html="$t('homePageTexts.videoContentForAnimationIntroFirst')"
    ></div>
    <img @load="picLoaded" class="gif" :src="getCurrentGif()" alt="" />
    <audio @ended="readyEnded" ref="ready">
      <source
        src="../assets/sound/fullscreensounds/ready.mp3"
        type="audio/mpeg"
      />
    </audio>
    <audio @ended="selectEnded" ref="select">
      <source
        src="../assets/sound/fullscreensounds/select_game_or_tutorial.mp3"
        type="audio/mpeg"
      />
    </audio>
  </div>
</template>

<script>
import appConstants from '@/config/constants';
import appConfig from '@/config/config';
import handHoverMixin from '@/mixins/hand-hover-mixin.js';

export default {
  name: 'intro',
  mixins: [handHoverMixin],
  props: {
    isData: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showBtns: false,
      isFirstIntroActive: true,
      currentGif: 'up',
      loadedPicsArr: [],
      btnClasses: {
        white: '',
        info: ''
      },
      isNotEnglish:localStorage.getItem('selectedLang') && localStorage.getItem('selectedLang')!='en'?'arabictextalign':''
    };
  },
  methods: {
    loadPics(picName) {
      if (!this.loadedPicsArr.includes(picName)) {
        this.loadedPicsArr.push(picName);
        this.$store.getters.getAppRootServices.reloadHoverableButtons();
      }
    },
    handleActivateEventInComponent(handlerId) {
      // functions map, using strategy:
      // debugger;
      const actions = {
        white: () => this.$router.push('/levels-selection/white'),
        info: () => this.$router.push('/animation-generator/tutorial')
      };
      if (actions[handlerId]) {
        this.currentGif = appConstants.gifs.out;
        setTimeout(() => {
          actions[handlerId]();
        }, appConfig.gifDelay);
      }
    },
    getImgNameExta(handlerId) {
      if (
        this.btnClasses[handlerId] === appConstants.hover ||
        this.btnClasses[handlerId] === appConstants.activate
      ) {
        return '_' + appConstants.hover;
      }
      return '';
    },
    getPic(handlerId) {
      try {
        return require(`@/assets/img/btns/${handlerId}${this.getImgNameExta(
          handlerId
        )}.png`);
      } catch (err) {
        console.warn({ err });
        return require('@/assets/img/btns/no.png');
      }
    },
    readyEnded() {
      this.showBtns = true;
      this.isFirstIntroActive = false;
      this.$refs.select.play();
    },
    selectEnded() {
      this.currentGif = appConstants.gifs.static;
    },
    picLoaded() {
      if (this.currentGif === appConstants.gifs.up) {
        setTimeout(() => {
          this.$refs.ready.play();
          this.currentGif = appConstants.gifs.talk;
        }, 700);
      }
    },
    getCurrentGif() {
      const imgs = {
        up: require('../assets/img/ninja_corner/corner_up.gif'),
        talk: require('../assets/img/ninja_corner/corner_talk.gif'),
        static: require('../assets/img/ninja_corner/ninja_corner.png'),
        out: require('../assets/img/ninja_corner/corner_down.gif')
      };
      return imgs[this.currentGif];
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/style.scss';

.gif {
  position: absolute;
}

.btn {
  position: absolute;
  z-index: 10;
  width: 7vw;
  top: 10%;
  &.hover,
  &:hover {
    // background-image: url('../assets/img/btns/progress_bar.gif');
    // background-position: center center;
    // background-repeat: no-repeat;
    // content: url('../assets/img/btns/progress_bar.gif');
  }
}

.white {
  width: 25%;
  left: 10%;
}

.info {
  top: 12%;
  width: 19%;
  right: 10%;
}
.langcontent {
  color: white;
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%; 
  font-size:25px;
}
#arabictextalign {
  direction: rtl;
}
</style>
